import { memo } from "react";
import {
  Heading,
  Text,
  CURRENCY_SYMBOLS,
  CurrencyType,
} from "@rshbintech.dboul/core-ui";
import { getPluralEnding } from "@rshbintech.dboul/utils";
import {
  CURRENCY_AMOUNT_INFO,
  DOCUMENT_PLURAL_FORMS,
  SELECTED_PLURAL_FORMS,
} from "../../constants";
import { DocumentsTotalProps } from "./types";
import { DOCUMENT_TOTAL_DICTIONARY, PLACEHOLDERS } from "./constants";
import styles from "./styles.scss";

export const DocumentsTotal = memo(
  ({ documentsLength, documentsInfo }: DocumentsTotalProps) => {
    const documentWordPluralForm = getPluralEnding(
      documentsLength,
      DOCUMENT_PLURAL_FORMS
    );

    const selectedWordPluralForm = getPluralEnding(
      documentsLength || 0,
      SELECTED_PLURAL_FORMS
    );

    const title = DOCUMENT_TOTAL_DICTIONARY.ALL_DOCUMENTS.replace(
      PLACEHOLDERS.NUMBER_OF_ALL_DOCUMENTS,
      String(documentsLength)
    )
      .replace(PLACEHOLDERS.DOCUMENT_WORD, documentWordPluralForm)
      .replace(PLACEHOLDERS.SELECTED, selectedWordPluralForm);

    return (
      <div className={styles["documents-total"]}>
        <div className={styles["documents-info"]}>
          <Heading level={5}>{title}:</Heading>
        </div>
        <div className={styles["documents-value"]}>
          {Object.entries(documentsInfo.totalDocuments).map(
            ([currency, { count, sum }]) => (
              <Text key={currency} size="large">
                {count} {CURRENCY_AMOUNT_INFO} &nbsp;
                <span className={styles.amount}>
                  {sum} {CURRENCY_SYMBOLS[currency as CurrencyType]}
                </span>
              </Text>
            )
          )}
        </div>
      </div>
    );
  }
);
